import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  let userType;
  if (sessionStorage.getItem("authUser")) {
    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    userType = obj;
}

  const [isFeira, setIsFeira] = useState(false);
  const [isFormaPagamento, setIsFormaPagamento] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [isReserva, setIsReserva] = useState(false);
  const [isVendas, setIsVendas] = useState(false);
  const [isMapaVendas, setIsMapaVendas] = useState(false);
  const [isSenha, setIsSenha] = useState(false);
  const [isUsuarios, setIsUsuarios] = useState(false);
  const [isLogs, setIsLogs] = useState(false);
  const [isTags, setIsTags] = useState(false);
  const [isListaEspera, setIsListaEspera] = useState(false);
  const [isListaEspaco, setIsListaEspaco] = useState(false);
  const [isSignIn, setIsSignIn] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const [isConfiguracaoGeral, setIsConfiguracaoGeral] = useState(false);

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history, iscurrentState]);

  const baseMenu = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "visao-geral",
      label: "Visão Geral",
      icon: "mdi mdi-view-dashboard",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Visao Geral");
      },
    },
  ];

  const cadastrosMenu = [
    {
      label: "Cadastros",
      isHeader: true,
    },
    {
      id: "feira",
      label: "Feiras",
      icon: "mdi mdi-briefcase",
      link: "/#",
      stateVariables: isFeira,
      click: function (e) {
        e.preventDefault();
        setIsFeira(!isFeira);
        setIscurrentState("Feiras");
        updateIconSidebar(e);
      },
      subItems: [
        { id: "lista-feira", label: "Lista", link: "/feiras-lista", parentId: "feiras" },
        { id: "cadastro-feira", label: "Cadastro", link: "/feira-cadastro", parentId: "feiras" }
      ],
    },
    {
      id: "pagamento",
      label: "Pagamento",
      icon: "mdi mdi-cash-multiple",
      link: "/#",
      stateVariables: isFormaPagamento,
      click: function (e) {
        e.preventDefault();
        setIsFormaPagamento(!isFormaPagamento);
        setIscurrentState("Formas de Pagamento");
        updateIconSidebar(e);
      },
      subItems: [
        { id: "condicao-pagamento", label: "Condição Pagamento", link: "/condicao-pagamento", parentId: "pagamento" },
        { id: "formas-pagamento", label: "Formas Pagamento", link: "/formas-pagamento", parentId: "pagamento" },
      ],
    },
    {
      id: "configuracao-geral",
      label: "Configuração Geral",
      icon: "mdi mdi-cog-outline",
      link: "/configuracao-geral",
      click: function (e) {
        e.preventDefault();
        setIsConfiguracaoGeral("Configuração Geral");
      },
    },
    {
      id: "tipo-espaco",
      label: "Tipo Espaço",
      icon: "mdi mdi-map-marker-multiple",
      link: "/tipo-espaco",
      click: function (e) {
        e.preventDefault();
        setIsTipoEspaco("Tipo Espaço");
      },
    },
    {
      id: "tags",
      label: "Tags",
      icon: "mdi mdi-tag",
      link: "/tags",
      click: function (e) {
        e.preventDefault();
        setIsTags(!isTags);
        setIscurrentState("Tags");
        updateIconSidebar(e);
      },
    },
    
    {
      id: "status",
      label: "Status Espaço",
      icon: "mdi mdi-home-modern",
      link: "/status-reserva",
      click: function (e) {
        e.preventDefault();
        setIsStatus(!isStatus);
        setIscurrentState("Status Espaço");
        updateIconSidebar(e);
      },
    },
  ];

  const cadastroEspaco = [
    {
      label: "CADASTROS",
      isHeader: true,
    },
    {
      id: "espacos",
      label: "Espaços",
      icon: "mdi mdi-list-box-outline",
      link: "/lista-espacos",
      click: function (e) {
        e.preventDefault();
        setIsListaEspaco(!isListaEpaco);
        setIscurrentState("Espaços");
        updateIconSidebar(e);
      },
    },
  ];

  const mapaInterno = [
    {
      label: "VENDAS",
      isHeader: true,
    },
    {
      id: "mapa",
      label: "Mapa",
      icon: "mdi mdi-television-guide",
      link: "/mapa-vendas",
      click: function (e) {
        e.preventDefault();
        setIsMapaVendas(!isMapaVendas);
        setIscurrentState("Mapa");
        updateIconSidebar(e);
      },
    },
  ];

  const processosMenu = [
    {
      label: "Processos",
      isHeader: true,
    },
    {
      id: "reservas",
      label: "Reservas",
      icon: "mdi mdi-cart-outline",
      link: "/reservas",
      click: function (e) {
        e.preventDefault();
        setIsReserva(!isReserva);
        setIscurrentState("Reservas");
        updateIconSidebar(e);
      },
    },
    {
      id: "vendas",
      label: "Vendas",
      icon: "mdi mdi-cart",
      link: "/vendas",
      click: function (e) {
        e.preventDefault();
        setIsVendas(!isVendas);
        setIscurrentState("Vendas");
        updateIconSidebar(e);
      },
    },
   {
      id: "senha",
      label: "Senhas Renovação",
      icon: "ri ri-lock-password-line",
      link: "/senhas",
      click: function (e) {
        e.preventDefault();
        setIsSenha(!isSenha);
        setIscurrentState("Senhas Renovação");
        updateIconSidebar(e);
      },
    },

    ...(userType?.user?.tipo === "JOTAPIX" || 
    userType?.user?.tipo === "EVOMAP" || 
    userType?.user?.tipo === "ORGANIZACAO"
    ? [{
        id: "espera",
        label: "Lista Espera",
        icon: "mdi mdi-list-box-outline",
        link: "/lista-espera",
        click: function (e) {
          e.preventDefault();
          setIsListaEspera(!isListaEspera);
          setIscurrentState("Lista Espera");
          updateIconSidebar(e);
        },
      }]
    : [])

  ];

  const adminMenu = [
    {
      label: "Administração",
      isHeader: true,
    },
    {
      id: "usuarios",
      label: "Usuários",
      icon: "mdi mdi-account-box",
      link: "/usuarios",
      click: function (e) {
        e.preventDefault();
        setIsUsuarios(!isUsuarios);
        setIscurrentState("Usuários");
        updateIconSidebar(e);
      },
    },
    
  ];

  const auditoriaMenu = [
    {
      label: "Auditoria",
      isHeader: true,
    },
    {
      id: "logs",
      label: "Logs",
      icon: "mdi mdi-clipboard-text",
      link: "/logs",
      click: function (e) {
        e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("Logs");
        updateIconSidebar(e);
      },
    },
  ];

  const possuiPermissao = (chaveBuscada) => {
    if (!userType?.user) return false;

    if (userType.user.permissoes?.permissoes) {
      return userType.user.permissoes.permissoes.some(p => p.chave === chaveBuscada);
    }

    if (userType.user.feiras) {
      return userType.user.feiras.some(feira => 
        feira.permissoes?.some(p => p.chave === chaveBuscada)
      );
    }

    return false;
  };

  const tipoUsuario = userType?.user?.tipo;

  const menuItems = [
    ...baseMenu,
    ...(tipoUsuario === "JOTAPIX" || tipoUsuario === "EVOMAP" ? cadastrosMenu : []),
    ...((tipoUsuario === "COMERCIAL" || tipoUsuario === "ORGANIZACAO") && possuiPermissao('CADASTRO_ESPAÇOS') 
        ? cadastroEspaco 
        : []),
    ...((tipoUsuario === "COMERCIAL" || tipoUsuario === "ORGANIZACAO") && possuiPermissao('MAPA_INTERNO') 
      ? mapaInterno 
      : []),
    ...((tipoUsuario === "JOTAPIX" || tipoUsuario === "EVOMAP") ? mapaInterno : []),
    ...processosMenu,
    ...(tipoUsuario === "JOTAPIX" || tipoUsuario === "EVOMAP" ? adminMenu : []),
    ...(tipoUsuario === "JOTAPIX" || tipoUsuario === "EVOMAP" || tipoUsuario === "ORGANIZACAO" ? auditoriaMenu : []),
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;

